export const PopoverStyles = {
  root: {
    background: 'var(--erma-primary-0)',
    borderColor: 'var(--erma-secondary-220)',
    borderRadius: 'var(--erma-border-radius-sm)',
    shadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
    gutter: '10px',
    arrowOffset: '1.25rem'
  },
  content: {
    padding: '1rem'
  }
};
